import axios from 'axios';

  let base = 'http://admin.spe.cps.com.cn';
//  let base = '/api';

//奖项
export const trend = params => { return axios.get(`${base}/cateFindOne`, {params:params})};

//表单提交
export const pinpaipingxuan = params => { return axios.post(`${base}/pinpaipingxuan`, params).then(res => res.data);};
// 示例
//export const trend = params => { return axios.get(`${base}/cateFindOne`, params).then(res => res.data); };
// export const addUser = params => { return axios.get(`${base}/user/add`, { params: params }); };


// WEBPACK FOOTER //
// ./src/api/api.js